import React, { useState, useEffect, useContext } from "react";
import "./cart.css";
import DeleteIcon from '@mui/icons-material/Delete';
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../constants/url";
import { CartContext } from "../../context/CartContext";
import Swal from "sweetalert2";

const CartItem = () => {
  const [cartItems, setCartItems] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();
  const { fetchCartCount } = useContext(CartContext);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      setIsLoggedIn(true);
      fetchCartItems(token);
    }
  }, []);

  const fetchCartItems = async (token) => {
    try {
      const response = await fetch(`${baseURL}common/cart/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      if (Array.isArray(data)) {
        setCartItems(data);
      } else if (Array.isArray(data?.cart_items)) {
        setCartItems(data.cart_items);
      } else {
        setCartItems([]);
      }
    } catch (err) {
      console.error("Error fetching cart items:", err);
      setCartItems([]);
    }
  };

  const increment = (index) => {
    const globalIndex = (currentPage - 1) * itemsPerPage + index;
    setCartItems((prev) =>
      prev.map((item, i) =>
        i === globalIndex ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const decrement = (index) => {
    const globalIndex = (currentPage - 1) * itemsPerPage + index;
    setCartItems((prev) =>
      prev.map((item, i) =>
        i === globalIndex && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  const handleDelete = async (product_variant_id) => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      const response = await fetch(`${baseURL}common/cart_delete/${product_variant_id}/`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        Swal.fire("Error", `Delete failed (${response.status})`, "error");
        return;
      }

      setCartItems((prev) =>
        prev.filter((item) => item.product_variant_id !== product_variant_id)
      );
      fetchCartCount();

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Product removed from cart.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });
    } catch (err) {
      console.error("Error deleting cart item:", err);
      Swal.fire("Error", "Unexpected error deleting cart item.", "error");
    }
  };

  const calculateTotalPrice = () => {
    return cartItems.reduce((total, item) => {
      return total + parseFloat(item.final_price || 0) * item.quantity;
    }, 0);
  };

  const handleCheckout = () => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate("/buynowcartaddress", { state: { cartItems } });
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginatedCartItems = cartItems.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(cartItems.length / itemsPerPage);

    const renderPagination = () => (
          <div className="pagination-wrapper">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => prev - 1)}  className="pagination_btn" >
              Previous
            </button>

            <span style={{ margin: "0 10px" }}>
              Page {currentPage} of {totalPages}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => prev + 1)} className="pagination_btn" >
              Next
            </button>
          </div>
        );


  return (
    <>
      <Header />
      <div className="bg_gray">
        <div className="container">
           <div className="row_old">
            <div className="col-lg-12_old">
              <div className="pt_20 pb_30">
                <div class="heading_common mt_15"><h3>My Cart Item</h3></div>
                <div className="cart_box bg_white_g mb_10 table-responsive">
                  <table className="widthFull cart_table table">
                    <thead>
                      <tr>
                        <th>Product Image</th>
                        <th>Product Name</th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Total</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedCartItems.length > 0 ? (
                        paginatedCartItems.map((item, index) => {
                          const price = parseFloat(item.final_price || 0);
                          const total = price * item.quantity;

                          return (
                            <tr key={item.product_variant_id}>
                              <td>
                                <div className="cart-image">
                                  <img src={item.product_image} alt="cart item img" />
                                </div>
                              </td>
                              <td>
                                <p className="font_12 color_lightDark">{item.product_name}</p>
                                <p>Size: {item.size || "N/A"}</p>
                              </td>
                              <td className="nowrap">₹ {price.toFixed(2)}</td>
                              <td className="nowrap">
                                <div className="quantity-wrapper">
                                  <button
                                    onClick={() => decrement(index)}
                                    className="border_right decrementBtn"
                                  >
                                    -
                                  </button>
                                  <span>{item.quantity.toString().padStart(2, "0")}</span>
                                  <button
                                    onClick={() => increment(index)}
                                    className="border_left incrementBtn"
                                  >
                                    +
                                  </button>
                                </div>
                              </td>
                              <td className="nowrap">₹ {total.toFixed(2)}</td>
                              <td>
                                <button
                                  type="button"
                                  className="delete_btn"
                                  title="Delete"
                                  onClick={() => handleDelete(item.product_variant_id)}
                                >
                                  <DeleteIcon className="color_red" />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>
                            Your cart is empty. 🛒
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {cartItems.length > 0 && (
                      <tfoot style={{ background: "#efefef" }}>
                        <tr>
                          <td colSpan={4} style={{ textAlign: "right", paddingRight: "30px" }}>
                            Total Price
                          </td>
                          <td colSpan={2}>₹ {calculateTotalPrice().toFixed(2)}</td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>

                {cartItems.length > 0 && (
                  <>
                    <div className="d_flex align_center justify_sp_between mt_20 pr_20 pb_30">
                      {renderPagination()}
                      <button
                        type="button"
                        title="Checkout"
                        className="update_proifile_btn"
                        onClick={handleCheckout}
                      >
                        Checkout
                      </button>
                    </div>

                    
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
};

export default CartItem;
